import React, { useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import { useNavigate } from "react-router-dom";
import CopyToClipboard from "react-copy-to-clipboard";

export const InitImg = ({ src }) => {
  const [imgloading, setImgloading] = useState(false);
  const [imgSrc, setImgSrc] = useState();
  useEffect(() => {
    const imgDom = new Image();
    setImgloading(true);
    imgDom.src = src;

    imgDom.onload = function () {
      setImgloading(false);
      setImgSrc(imgDom.src);
    };
  }, [src]);
  const LodingRender = () => {
    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignContent: "center",
          paddingTop: "34px",
        }}
      >
        <ReactLoading
          type="spinningBubbles"
          color="#215ae5"
          height={40}
          width={40}
        />
      </div>
    );
  };
  return imgloading ? LodingRender() : <img src={imgSrc} alt="authing" />;
};

export const ContactBar = () => {
  const nav = useNavigate();
  const { t } = useTranslation();
  const contactMobileBarRender = () => {
    return (
      <div className="contact-bar-mobile">
        <div className="contact-bar-warp">
          <div
            className="online-button button"
            onClick={() => {
              _MEIQIA("assign", {
                agentToken: "06da7d49fcc1d84cc76efa1a2f8db954",
              });
              _MEIQIA("showPanel");
            }}
          >
            <>
              <i className="icon authing-icon authing-customer-service-2-linebeifen"></i>
              <span> {t("common.chat-online")}</span>
            </>
          </div>
          <a className="phone-button button" href="tel:400 888 2106">
            <i className="icon authing-icon authing-phone-linebeifen"></i>
            <span>{t("common.chat-phone")}</span>
          </a>
        </div>
      </div>
    );
  };
  const [copy, setCopy] = useState({
    phone: false,
    email: false,
  });
  const [copied, setCopied] = useState(false);
  const contactBarRender = () => {
    return (
      <div
        className="contact-bar"
        onMouseLeave={() => {
          setCopy((copy) => ({
            ...copy,
            phone: false,
            email: false,
          }));
        }}
      >
        <div className="contact-bar-warp">
          <div
            className="chat-online bar-item"
            data-log="sidebar/online"
            onClick={() => {
              _MEIQIA("assign", {
                agentToken: "06da7d49fcc1d84cc76efa1a2f8db954",
              });
              _MEIQIA("showPanel");
            }}
          >
            <div className="contact-icon ">
              <i className="icon website-icon website-zaixianzixun"></i>
            </div>
            <div className="bar-item-label">{t("common.chatrobot.online")}</div>
            <div className="tip chat-online-tip">
              <div className="title">{t("common.chatrobot.onlineTip1")}</div>
              <div className="subtitle">{t("common.chatrobot.onlineTip2")}</div>
            </div>
          </div>

          <div className="wechat bar-item">
            <div className="contact-icon">
              <i className="icon website-icon website-qiweizixun"></i>
            </div>
            <div className="bar-item-label">{t("common.chatrobot.wecom")}</div>
            <div className="wechat-robot-content">
              <div className="wechat-robot-reqcode">
                <InitImg src="//files.authing.co/authing-website/wechat-enterprice-code.png" />
              </div>
              <div className="text">{t("common.chatrobot.wecomTip")}</div>
              {/* <div className="text"></div> */}
            </div>
          </div>
          <div
            className="quotation-consultation bar-item"
            data-log="sidebar/quotation"
          >
            <a href="mailto:ceo@authing.com">
              <div
                className="contact-icon"
                style={{
                  color: copy.email ? "#215AE5" : "",
                }}
              >
                <i className="icon website-icon website-a-CEOyouxiang"></i>
              </div>

              <div
                className="bar-item-label"
                style={{
                  color: copy.email ? "#215AE5" : "",
                }}
              >
                {t("common.chatrobot.ceoEmail")}
              </div>
              <CopyToClipboard
                text={"ceo@authing.com"}
                onCopy={() => {
                  setCopy((copy) => ({
                    ...copy,
                    phone: false,
                    email: true,
                  }));
                }}
              >
                <div className="tip quotation-consultation-tip">
                  <div
                    className="title"
                    style={{
                      color: copy.email ? "#215AE5" : "",
                    }}
                  >
                    ceo@authing.com
                    {copy.email && (
                      <span className="already-copy">
                        {t("common.chatrobot.alreadyCopy")}
                      </span>
                    )}
                  </div>

                  <div className="subtitle">
                    {t("common.chatrobot.ceoEmailTip")}
                  </div>
                </div>
              </CopyToClipboard>
            </a>
          </div>

          <div className="phone bar-item">
            <a href="tel:400-888-2106">
              <div
                className="contact-icon"
                style={{
                  color: copy.phone ? "#215AE5" : "",
                }}
              >
                <i className="icon website-icon website-dianhuazixun"></i>
              </div>
              <div
                className="bar-item-label"
                style={{
                  color: copy.phone ? "#215AE5" : "",
                }}
              >
                {t("common.chatrobot.phone")}
              </div>
              <CopyToClipboard
                text={"400-888-2106"}
                onCopy={() => {
                  setCopy((copy) => ({
                    ...copy,
                    email: false,
                    phone: true,
                  }));
                }}
              >
                <div className="tip phone-box">
                  <div
                    className="title"
                    style={{
                      color: copy.phone ? "#215AE5" : "",
                    }}
                  >
                    400-888-2106
                    {copy.phone && (
                      <span className="already-copy">
                        {t("common.chatrobot.alreadyCopy")}
                      </span>
                    )}
                  </div>
                  <div className="subtitle">
                    {t("common.chatrobot.phoneTip")}
                  </div>
                </div>
              </CopyToClipboard>
            </a>
          </div>

          <div className="token bar-item">
            <div className="contact-icon">
              <i className="icon website-icon website-xiazailingpai"></i>
            </div>
            <div className="bar-item-label">{t("common.chatrobot.token")}</div>
            <div className="token-robot-content">
              <div className="token-robot-reqcode-warp">
                <div className="token-robot-reqcode">
                  <InitImg src="//files.authing.co/authing-website/token-ios-code.svg" />
                </div>
                <div className="token-robot-reqcode">
                  <InitImg src="//files.authing.co/authing-website/token-android-code.svg" />
                </div>
              </div>
              <div className="text">{t("common.chatrobot.tokenTip")}</div>
            </div>
          </div>
        </div>

        <div
          className="free-use-button"
          onClick={() => {
            nav("/authingform?fromTag=侧栏");
          }}
        >
          <i className="icon website-icon website-mianfeishiyong free-use-icon"></i>
          <div className="free-use-text">{t("common.chatrobot.freeUse")}</div>
        </div>
      </div>
    );
  };
  return (
    <>
      {contactBarRender()}
      {contactMobileBarRender()}
    </>
  );
};
